<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Category
    </button>

    <a-modal v-model="visible" title="Add new category">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input category name!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
          />
        </a-form-item>
<!--        <a-form-item label="Category Code">
          <a-input
            placeholder="Category code. eg: SKU1129930"
            v-decorator="['code', {rules: [{ required: true, message: 'Please input category code!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
          />
        </a-form-item>-->
        <a-form-item label="Parent category">
          <a-select placeholder="Select parent category" v-decorator="['parent_category_id', { rules: [{ required: false, message: 'Please select a category!'}], initialValue: undefined}]">
            <a-select-option :value="undefined">
              Select parent category
            </a-select-option>
            <a-select-option v-for="(cat, index) in parentCategories" :key="index" :value="cat.id">{{cat.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

import { fetchInventoryData } from '@/components/inventory/common'
/* const clearform = (form) => {
  // console.log('form', form)
  // console.log(form.fieldsStore)
  // console.log(Object.keys(form.fieldsStore.fields))
  try {
    let fieldnames = Object.keys(form.fieldsStore.fields)
    fieldnames.map((e, index) => {
      form.setFieldsValue({ [e]: undefined })
    })
  } catch (err) {
    console.error(err)
  }
} */
export default {
  name: 'NewCategory',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      categories: [],
      parentCategories: [],
    }
  },
  mounted: function() {
    let d = fetchInventoryData('category')
    d.then(data => { this.categories = data.data }).catch(err => console.error(err))
  },
  watch: {
    formVisible: function(n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    showModal() {
      this.visible = true
      this.getParentCategories()
    },
    getParentCategories: function() {
      this.$http.get('/api/library/category')
        .then(({ data }) => {
          this.categories = data.data
          this.parentCategories = this.categories.filter((category) => category.parent_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // getParentCategories: function () {
    //   this.$http.get('/api/library/category')
    //     .then(({ data }) => {
    //       this.allCategories = data.data
    //       this.categories = this.allCategories.filter((category) => category.parent_id === null)
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    savedata: function() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // clearform(this.form)
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new category!`,
            onOk: () => {
              this.$http.post('/api/library/category', {
                name: values.name,
                description: values.description,
                category_id: values.category_id,
                parent_category_id: values.parent_category_id,
                remark: '',
                status: 1,
                code: values.code,
              })
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200) {
                    this.$notification['success']({
                      message: 'Category created successfully',
                      description: `${values.name} added successfully!`,
                    })
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>

<style>

</style>
